package org.lennycodes.hldi.pages

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.*
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.components.layout.SimpleGrid
import com.varabyte.kobweb.silk.style.breakpoint.ResponsiveValues
import com.varabyte.kobweb.silk.style.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.css.JustifyContent
import org.jetbrains.compose.web.dom.*
import org.lennycodes.hldi.components.BlogCard
import org.lennycodes.hldi.components.HeroSection
import org.lennycodes.hldi.constants.HLDITheme
import org.lennycodes.hldi.data.BlogPost
import org.lennycodes.hldi.data.GalleryImage
import org.lennycodes.hldi.layouts.MainLayout
import org.lennycodes.hldi.pages.admin.AdminRepository
import org.lennycodes.hldi.styles.AboutHeroSectionStyle
import org.lennycodes.hldi.styles.AboutHeroTextStyle
import org.lennycodes.hldi.styles.AboutHeroTitleStyle
import org.lennycodes.hldi.styles.HeroSectionStyle
import org.lennycodes.hldi.styles.HeroTextStyle
import org.lennycodes.hldi.styles.HeroTitleStyle
import org.lennycodes.hldi.styles.SectionWaveSvg
import org.lennycodes.hldi.styles.SpinnerStyle

val categories = listOf("All", "Education", "Legal Aid", "Health", "Community Development")

@Composable
@Page("/blog")
fun BlogPage() {

    var isLoading by remember { mutableStateOf(true) }

    var blogPosts by remember { mutableStateOf<List<BlogPost>>(emptyList()) }
    var selectedCategory by remember { mutableStateOf("All") }


    LaunchedEffect(Unit) {

        try {

            blogPosts = AdminRepository.getAllBlogs()

        } finally {

            isLoading = false

        }

    }


    MainLayout {

        Section(
            attrs = Modifier.padding(50.px, 20.px).then(AboutHeroSectionStyle.toModifier())
                .toAttrs()
        ) {
            H1(attrs = AboutHeroTitleStyle.toAttrs()) {
                Text("Our Blog")
            }
            P(
                attrs = AboutHeroTextStyle.toAttrs {
                    style { maxWidth(700.px) } // wider than the shared 600px default for this section's longer copy
                }
            ) {
                Text("Stories, news, and updates from our humanitarian work across Tanzania.")
            }
            SectionWaveSvg()
        }


        // Category Filter
        Section(
            attrs = Modifier
                .margin(top = 75.px)
                .padding(0.px, 20.px, 40.px)
                .toAttrs()
        ) {
            Div(
                attrs = {
                    style {
                        display(DisplayStyle.Flex)
                        gap(12.px)
                        justifyContent(JustifyContent.Center)
                        flexWrap(FlexWrap.Wrap)
                    }
                }
            ) {
                categories.forEach { category ->
                    Button(
                        attrs = {
                            style {
                                padding(10.px, 24.px)
                                borderRadius(24.px)
                                border(1.px, LineStyle.Solid, HLDITheme.Colors.primary)
                                backgroundColor(
                                    if (selectedCategory == category) HLDITheme.Colors.primary
                                    else HLDITheme.Colors.tranparent
                                )
                                color(
                                    if (selectedCategory == category) HLDITheme.Colors.white
                                    else HLDITheme.Colors.primary
                                )
                                fontSize(14.px)
                                fontWeight(500)
                                cursor(Cursor.Pointer)
                                transition(
                                    Transition.of(
                                        property = "all",
                                        duration = 400.ms,
                                        timingFunction = TransitionTimingFunction.Ease
                                    )
                                )
                            }
                            onClick { selectedCategory = category }
                        }
                    ) {
                        Text(category)
                    }
                }
            }
        }

        // Blog Posts Grid
        Section(
            attrs = Modifier
                .margin(32.px)
                .toAttrs()
        ) {

            val filteredPosts = if (selectedCategory == "All")
                blogPosts
            else
                blogPosts.filter { it.category == selectedCategory }


            when {

                isLoading -> {

                    Div(

                        attrs = Modifier
                            .fillMaxWidth()
                            .padding(40.px)
                            .toAttrs {

                                style {

                                    property("display", "flex")

                                    property("justify-content", "center")

                                    property("align-items", "center")

                                }

                            }

                    ) {

                        Div(

                            attrs = Modifier
                                .size(45.px)
                                .then(SpinnerStyle.toModifier())
                                .toAttrs()

                        )

                    }

                }


                filteredPosts.isEmpty() -> {

                    P(

                        attrs = {

                            style {

                                textAlign(TextAlign.Center)

                                fontSize(16.px)

                                color(HLDITheme.Colors.mediumGray)

                            }

                        }

                    ) {

                        Text(
                            if (selectedCategory == "All")
                                "No blog posts available yet."
                            else
                                "No blog posts in this category yet."
                        )

                    }

                }


                else -> {

                    SimpleGrid(
                        numColumns = ResponsiveValues(
                            1, // base (xs)
                            1, // sm
                            2, // md
                            3,  // lg+
                            4,
                            5
                        ),
                        modifier = Modifier.gap(24.px)
                    ) {
                        filteredPosts.forEach { post ->
                            BlogCard(post)
                        }
                    }

                }

            }

        }
    }
}